import React from 'react';
import Grid from '@material-ui/core/Grid';

export default function PointSelectionTextAbove(props) {
  return (
    <Grid container direction="row" justify="center" alignItems="center">
      {/*empty item, just occupying space for most left dot */}
      <Grid item>
        <div style={{ width: '44px', height: '1px' }} />
      </Grid>

      <Grid item>
        <div style={{ width: '110px' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <span>{props.firstText}</span>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/*empty item, just occupying space for centered dot */}
      <Grid item>
        <div style={{ width: '22px', height: '1px' }} />
      </Grid>

      <Grid item>
        <div style={{ width: '110px' }}>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid item>
              <span>{props.secondText}</span>
            </Grid>
          </Grid>
        </div>
      </Grid>

      {/*empty item, just occupying space for most left dot */}
      <Grid item>
        <div style={{ width: '44px', height: '1px' }} />
      </Grid>
    </Grid>
  );
}
